import { Fragment, useRef } from "react"
import { observer } from "mobx-react"
import { Dialog, Transition } from "@headlessui/react"
import { useStore } from "@features/common"
import { IconClose } from "@lib/icons"
import classNames from "classnames"
import { mergeClasses } from "@lib/css"
import { ModalBorders } from "@features/common/atoms/modal-borders"

export const ModalContainer = observer(function ModalContainer() {
  const {
    ModalModel: { isOpen, content, isDarkTheme, isNewType, close },
    ResponsiveModel: { height },
  } = useStore()

  const closeButtonRef = useRef(null)

  return (
    <Transition appear={true} as={Fragment} show={isOpen}>
      <Dialog
        as="div"
        initialFocus={closeButtonRef}
        className="fixed inset-0 z-100 overflow-hidden"
        onClose={close}
        style={{ height: height > 0 ? `${height}px` : "100%" }}
      >
        <div
          className={classNames("w-full h-full text-center overflow-auto", {
            "tablet-s:px-4": !isNewType,
          })}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-70" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={mergeClasses(
                "flex w-full h-full",
                isNewType
                  ? "justify-stretch items-end laptop:justify-center laptop:items-center"
                  : "justify-center items-center",
              )}
            >
              <div
                className={mergeClasses(
                  "relative flex flex-col max-h-full overflow-y-auto",
                  isNewType
                    ? "w-full laptop:max-w-[91rem] laptop:mx-auto laptop:px-10 desktop-xl:px-0"
                    : "justify-center h-full tablet-s:h-auto tablet-s:w-128 tablet-s:overflow-visible",
                )}
              >
                <button
                  className={classNames("outline-none z-2 absolute", {
                    "text-black tablet-s:text-white": !isDarkTheme,
                    "text-white": isDarkTheme,
                    "top-4 right-4 tablet-s:top-0 tablet-s:-right-12": !isNewType,
                    "sticky top-0 right-0 pt-10 px-4 pb-4 self-end tablet-s:text-white tablet-s:pt-0 tablet-s:px-0 tablet-s:pr-6 laptop:pr-0": isNewType,
                  })}
                  onClick={close}
                >
                  <IconClose className="w-8 h-8" />
                </button>
                <div
                  className={classNames("z-1", {
                    "text-white": isDarkTheme,
                    "h-full": !isNewType,
                    "pt-2 laptop:p-2": isNewType,
                  })}
                >
                  <div
                    className={classNames("relative", {
                      "bg-gray-400": isDarkTheme,
                      "bg-white": !isDarkTheme,
                      "flex flex-col justify-center h-full tablet-s:h-auto overflow-y-auto tablet-s:overflow-visible": !isNewType,
                    })}
                  >
                    {isNewType && <ModalBorders isDarkTheme={isDarkTheme} />}
                    {content}
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
})
